import React, { FC } from 'react';
import { WithTranslation } from 'react-i18next';
import { UploadStatus } from 'ia-react-core/~/interfaces/UploadStatus';

import usePixelRatio from '../../../hooks/_usePixelRatio';
import File from './File';
import { StyledFileList } from './FileList.styles';

export interface FileListProps {
  files?: InstanceType<typeof window.File>[];
  statuses?: UploadStatus[];
  onRetry?: (index: number) => void;
  onDelete?: (index: number) => void;
}

interface FileListComposedProps extends FileListProps, WithTranslation {}

const FileListDefaultProps: Partial<FileListProps> = {
  files: [],
  statuses: [],
};

const FileList: FC<FileListComposedProps> = ({ files, statuses, t, tReady, onRetry, onDelete, ...props }) => {
  const pixelRatio = usePixelRatio();

  return (
    <StyledFileList {...props}>
      {files.map((file, index) => (
        <File
          // eslint-disable-next-line react/no-array-index-key
          key={`${file.name}${index}`}
          file={file}
          progress={statuses[index]?.progress}
          success={statuses[index]?.success}
          error={statuses[index]?.error}
          onRetry={onRetry}
          onDelete={onDelete}
          index={index}
          pixelRatio={pixelRatio}
        />
      ))}
    </StyledFileList>
  );
};

FileList.defaultProps = FileListDefaultProps;

export default FileList;
